<template>
    <div class="mb-3">
        <h3>Contact Information</h3>

        <div class="mb-3">
            <div class="form-floating">
                <input class="form-control" id="floatingContactName" v-model="store.contactName" placeholder="" :class="{ 'is-invalid': v$.contactName.$errors.length > 0 }" />
                <label for="floatingContactName">Name: <span class="required">*</span></label>
            </div>
            <div v-for="error of v$.contactName.$errors" :key="error.$uid" class="error">{{ error.$message }}</div>
        </div>

        <div class="mb-3">
            <div class="form-floating">
                <input class="form-control" id="floatingContactPhone" v-model="store.contactPhone" placeholder="" :class="{ 'is-invalid': v$.contactPhone.$errors.length > 0 }" />
                <label for="floatingContactPhone">Phone: <span class="required">*</span></label>
            </div>
            <div v-for="error of v$.contactPhone.$errors" :key="error.$uid" class="error">{{ error.$message }}</div>
        </div>

        <div class="mb-3">
            <div class="form-floating">
                <input class="form-control" id="floatingContactEmail" v-model="store.contactEmail" placeholder="" :class="{ 'is-invalid': v$.contactEmail.$errors.length > 0 }" />
                <label for="floatingContactEmail">Email: <span class="required">*</span></label>
            </div>
            <div v-for="error of v$.contactEmail.$errors" :key="error.$uid" class="error">{{ error.$message }}</div>
        </div>

        <div class="text-center">
            <button type="button" class="btn btn-outline-primary me-3" @click="goBackToPage('DATES')">Back</button>
            <button type="button" class="btn btn-primary" @click="goToPage('PAYMENT')">Next</button>
        </div>
    </div>
</template>

<script setup>
    import { computed } from 'vue';
    import { useStore } from './store';
    import useVuelidate from '@vuelidate/core';
    import { required, email } from '@vuelidate/validators';

    const emit = defineEmits(['goToPage', 'goBackToPage']);

    const store = useStore();

    const rules = computed(() => ({
        contactName: { required },
        contactPhone: { required },
        contactEmail: { required, email }
    }));

    const v$ = useVuelidate(rules, store);

    async function goToPage(pageName) {
        var isValid = await v$.value.$validate();

        if (isValid) { emit('goToPage', pageName); }
            
    }

    function goBackToPage(pageName) {
        emit('goBackToPage', pageName);
    }


</script>